.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  height: var(--control-height);
  padding: 0 var(--space-3);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: var(--text-md);
  font-weight: var(--weight-medium);
  line-height: 1;
  white-space: nowrap;
  user-select: none;
  transition:
    background-color var(--duration-fast) var(--ease),
    border-color var(--duration-fast) var(--ease),
    color var(--duration-fast) var(--ease),
    box-shadow var(--duration-fast) var(--ease);
}

.button:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

.link,
.link:hover {
  text-decoration: none;
}

.button:disabled {
  opacity: 0.55;
}

.button svg {
  flex: none;
  width: 16px;
  height: 16px;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.sm {
  height: var(--control-height-sm);
  padding: 0 var(--space-2);
  gap: var(--space-1);
  font-size: var(--text-sm);
}

.sm svg {
  width: 14px;
  height: 14px;
}

.primary {
  background: var(--accent);
  color: var(--on-accent);
}

.primary:hover:not(:disabled) {
  background: var(--accent-hover);
}

.secondary {
  background: var(--surface);
  border-color: var(--border-strong);
  color: var(--text);
  box-shadow: var(--shadow-sm);
}

.secondary:hover:not(:disabled) {
  background: var(--surface-2);
}

.ghost {
  background: transparent;
  color: var(--text-muted);
}

.ghost:hover:not(:disabled) {
  background: var(--surface-3);
  color: var(--text);
}

.danger {
  background: var(--danger);
  color: var(--on-danger);
}

.danger:hover:not(:disabled) {
  background: var(--danger-hover);
}

.iconOnly {
  width: var(--control-height);
  padding: 0;
}

.iconOnly.sm {
  width: var(--control-height-sm);
}

.pressed,
.pressed:hover:not(:disabled) {
  background: var(--accent-soft-strong);
  color: var(--accent);
}
